export const ROUTES = {
  login: '/admin/auth/login',
  dashboard: '/admin/dashboard',
  profile: '/admin/profile',
  users: '/admin/users',
  services: '/admin/services',
  slots: '/admin/slots',
  promoCodes: '/admin/promo-codes/:id',
  createPromoCode: '/admin/promo-codes/create',
  promoCodeAnalytics: '/admin/promo-codes/analytics',
  reports: '/admin/reports',
  uploadReports: '/admin/reports/upload',
  sentReports: '/admin/reports/sent',
  emailTemplates: '/admin/reports/templates',
  content: '/admin/content',
  homeContent: '/admin/content/home',
  aboutContent: '/admin/content/about',
  contactContent: '/admin/content/contact',
  policiesContent: '/admin/content/policies',
  seo: '/admin/seo',
};
